var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoverLatest1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 208,
    viewBox: "0 0 1440 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_9494)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 365,
    fill: "#242932"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 768.277,
    y: -330,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 768.277 -330)",
    fill: "url(#paint0_linear_840_9494)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.527,
    y: -302.199,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 796.527 -302.199)",
    fill: "url(#paint1_linear_840_9494)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 824.777,
    y: -274.398,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 824.777 -274.398)",
    fill: "url(#paint2_linear_840_9494)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 853.027,
    y: -246.596,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 853.027 -246.596)",
    fill: "url(#paint3_linear_840_9494)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 881.277,
    y: -218.795,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 881.277 -218.795)",
    fill: "url(#paint4_linear_840_9494)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 909.527,
    y: -190.994,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 909.527 -190.994)",
    fill: "url(#paint5_linear_840_9494)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 937.777,
    y: -163.193,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 937.777 -163.193)",
    fill: "url(#paint6_linear_840_9494)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 966.027,
    y: -135.391,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 966.027 -135.391)",
    fill: "url(#paint7_linear_840_9494)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 994.277,
    y: -107.59,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 994.277 -107.59)",
    fill: "url(#paint8_linear_840_9494)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.0469,
    y: -306.467,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 95.0469 -306.467)",
    fill: "url(#paint9_linear_840_9494)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.297,
    y: -278.666,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 123.297 -278.666)",
    fill: "url(#paint10_linear_840_9494)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.547,
    y: -250.865,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 151.547 -250.865)",
    fill: "url(#paint11_linear_840_9494)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.797,
    y: -223.062,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 179.797 -223.062)",
    fill: "url(#paint12_linear_840_9494)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.047,
    y: -195.262,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 208.047 -195.262)",
    fill: "url(#paint13_linear_840_9494)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.297,
    y: -167.461,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 236.297 -167.461)",
    fill: "url(#paint14_linear_840_9494)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.547,
    y: -139.66,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 264.547 -139.66)",
    fill: "url(#paint15_linear_840_9494)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.797,
    y: -111.857,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 292.797 -111.857)",
    fill: "url(#paint16_linear_840_9494)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.047,
    y: -84.0566,
    width: 12.4194,
    height: 1183.3,
    transform: "rotate(44.5414 321.047 -84.0566)",
    fill: "url(#paint17_linear_840_9494)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_840_9494",
    x1: 774.487,
    y1: -330,
    x2: 774.487,
    y2: 853.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EF32D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_840_9494",
    x1: 802.737,
    y1: -302.199,
    x2: 802.737,
    y2: 881.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EF32D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_840_9494",
    x1: 830.987,
    y1: -274.398,
    x2: 830.987,
    y2: 908.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EF32D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_840_9494",
    x1: 859.237,
    y1: -246.596,
    x2: 859.237,
    y2: 936.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EF32D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_840_9494",
    x1: 887.487,
    y1: -218.795,
    x2: 887.487,
    y2: 964.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EF32D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_840_9494",
    x1: 915.737,
    y1: -190.994,
    x2: 915.737,
    y2: 992.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EF32D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_840_9494",
    x1: 943.987,
    y1: -163.193,
    x2: 943.987,
    y2: 1020.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EF32D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_840_9494",
    x1: 972.237,
    y1: -135.391,
    x2: 972.237,
    y2: 1047.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EF32D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_840_9494",
    x1: 1000.49,
    y1: -107.59,
    x2: 1000.49,
    y2: 1075.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EF32D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_840_9494",
    x1: 101.257,
    y1: -306.467,
    x2: 101.257,
    y2: 876.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_840_9494",
    x1: 129.507,
    y1: -278.666,
    x2: 129.507,
    y2: 904.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_840_9494",
    x1: 157.757,
    y1: -250.865,
    x2: 157.757,
    y2: 932.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_840_9494",
    x1: 186.007,
    y1: -223.063,
    x2: 186.007,
    y2: 960.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_840_9494",
    x1: 214.257,
    y1: -195.262,
    x2: 214.257,
    y2: 988.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_840_9494",
    x1: 242.507,
    y1: -167.461,
    x2: 242.507,
    y2: 1015.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_840_9494",
    x1: 270.757,
    y1: -139.66,
    x2: 270.757,
    y2: 1043.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_840_9494",
    x1: 299.007,
    y1: -111.857,
    x2: 299.007,
    y2: 1071.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_840_9494",
    x1: 327.257,
    y1: -84.0566,
    x2: 327.257,
    y2: 1099.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15151F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_9494"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V192C1440 200.837 1432.84 208 1424 208H16C7.16349 208 0 200.837 0 192V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverLatest1);
export default __webpack_public_path__ + "static/media/cover-latest1.ab33569bd9bb26b93605eecc9cbe894d.svg";
export { ForwardRef as ReactComponent };